import { constants } from "../constants/redux-constants";

const initialState = {
  encounter: {},
  visitList: {},
  toggleSelect: true,
  encounterResource: {},
};

const EncounterReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants?.ENCOUNTER?.ENCOUNTER_OBJECT:
      return {
        ...state,
        encounter: action?.payload,
      };
    case constants?.ENCOUNTER?.VISIT_OBJECT:
      return {
        ...state,
        visitList: action?.payload,
      };
    case constants?.ENCOUNTER?.ADD_VISIT:
      return {
        ...state,
        visitList: [action?.payload, ...state?.visitList],
      };

    case constants?.ENCOUNTER?.TOGGLE_SELECT:
      return {
        ...state,
        toggleSelect: action?.payload,
      };

    case constants?.ENCOUNTER?.ENCOUNTER_RESOURCE:
      return {
        ...state,
        encounterResource: action?.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export default EncounterReducer;
